import React from 'react';
import { FunctionComponent } from 'react';
import styled from 'styled-components';

const Content: FunctionComponent<{ className?: string }> = () => (
    <svg width='33' height='32' viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
            d='M15.6641 3L15.3516 3.28125L8.57031 10H2.97656V26H19.8203C21.2305 26 22.4609 25.0039 22.7578 23.625L24.4141 16H27.9766C29.6211 16 30.9766 14.6445 30.9766 13C30.9766 11.3555 29.6211 10 27.9766 10H17.2266L17.4141 9.25C17.6172 9.09375 17.7461 9.02734 18.0391 8.625C18.5078 7.98438 18.9766 6.99219 18.9766 5.65625C18.9766 4.23047 17.6875 3 16.0703 3H15.6641ZM16.3828 5.09375C16.8047 5.17578 16.9766 5.34766 16.9766 5.65625C16.9766 6.55859 16.7031 7.11719 16.4453 7.46875C16.1875 7.82031 16.0078 7.90625 16.0078 7.90625L15.6641 8.09375L15.5391 8.5L14.9453 10.75L14.6328 12H27.9766C28.543 12 28.9766 12.4336 28.9766 13C28.9766 13.5664 28.543 14 27.9766 14H22.7891L22.6016 14.7812L20.8203 23.2188C20.7188 23.6875 20.2969 24 19.8203 24H9.97656V11.4062L16.3828 5.09375ZM4.97656 12H7.97656V24H4.97656V12Z'
            fill='white'
        />
    </svg>
);

const PointRightFinger = styled(Content)`
    width: 32px;
    height: 32px;
`;

export default PointRightFinger;
